import dayjs from 'dayjs'
import type { FC } from 'react'

import type { IPatientSchedule } from 'features/Home/interfaces/IInfoSchedule'

import styles from './ehrAppointmentV2.module.scss'

type Props = {
  appointment?: IPatientSchedule
}

// EMR sends 0000-00-00 for rows it never stamped; those must not render as Invalid Date.
const stamp = (value?: string | null): string => {
  if (!value) return ''
  const date = dayjs(value)
  return date.isValid() ? date.format('MM/DD/YYYY hh:mm A') : ''
}

export const AuditLines: FC<Props> = ({ appointment }) => {
  if (!appointment?.created_by && !appointment?.updated_at) return null

  return (
    <div className={styles.auditLines}>
      {appointment?.created_by && (
        <p>
          Originally created by {appointment.created_by.user_name}{' '}
          {stamp(appointment.created_by.created_at)}
        </p>
      )}
      {appointment?.updated_at && stamp(appointment.updated_at) && (
        <p>
          Last updated by {appointment.updated_by} on {stamp(appointment.updated_at)}
        </p>
      )}
    </div>
  )
}
